<div class="section border-bottom p-4"
    [class.editing]="editing"
    [class.editable]="editable">
    <div *ngIf="showHeader"
        class="d-flex flex-row">

        <div *ngIf="handler.icon"
            title="{{ handler.onIconClicked && entity ? ('ADMIN.EDITOR.PICTURE_UPLOAD_TIP' | translate) : '' }}"
            (click)="onIconClicked()">

            <div class="section-image mr-3"
                [class.pointer]="handler.onIconClicked && entity">

                <img *ngIf="handler.icon.startsWith('data:')"
                    [src]="handler.icon" />

                <kui-icon *ngIf="!handler.icon.startsWith('data:')"
                    class="section-icon icon-light"
                    fixedWidth="true"
                    [name]="handler.icon"
                    [size]="'xl'"></kui-icon>


                <kui-icon *ngIf="handler.onIconClicked && entity"
                    class="overlay"
                    name="camera-alt"
                    size="lg"></kui-icon>

            </div>

        </div>

        <div class='center-column flex-1'>

            <div class="d-flex">
                <div class="flex-1">
                    <h4 class="title">{{ handler.title }}</h4>
                </div>
                <div class="icon-light ml-3"
                    *ngIf="handler && editable && !editing && !handler.readonly">
                    <kui-icon kui-action
                        name="edit"
                        [size]="'sm'"
                        (click)="onEdit.emit()"></kui-icon>
                </div>
            </div>

            <div *ngIf="handler.description"
                class='section-description muted'>
                {{ handler.description }}
            </div>

            <ng-content select="[inside]"></ng-content>

        </div>
    </div>

    <div *ngIf="handler.warning && !editing"
        class="border py-2 px-3 mt-3">
        <kui-icon class="pr-2"
            name="exclamation-triangle"
            [size]="'sm'"></kui-icon>
        {{ handler.warning }}
    </div>

    <ng-content select="[outside]"></ng-content>

    <div class="flex-1 text-left"
        *ngIf="!editing">
        <button kui-button
            class='mt-3 mr-2'
            *ngFor="let action of staticActions"
            (click)="onAction.emit(action.id || action.name)"
            color="secondary"
            [kui-tooltip]="action.name">
            <kui-icon kui-action
                *ngIf="action.icon"
                name="action.icon"
                [size]="'sm'"></kui-icon>
            {{ action.name }}
        </button>
    </div>

    <div *ngIf="errorMessage">
        <kui-alert type="none"
            class="key-alert-wrapper bordered no-padding my-2">
            <kui-icon name="exclamation"
                class="muted-more"
                size="lg"></kui-icon>
            <span>{{errorMessage}}</span>
        </kui-alert>
    </div>

    <div *ngIf="editing"
        class="buttons d-flex">
        <div class="flex-1">
            <button kui-button
                *ngFor="let action of actions"
                (click)="onAction.emit(action.id || action.name)"
                color="secondary"
                kui-tooltip="action.name">
                <kui-icon kui-action
                    *ngIf="action.icon"
                    name="action.icon"
                    [size]="'sm'"></kui-icon>
                {{ action.name }}
            </button>
        </div>
        <div class="text-right">
            <button kui-button
                *ngIf="!handler.buttons || handler.buttons.includes('cancel')"
                (click)="onCancel.emit()"
                color="secondary">
                {{ 'DIALOG.CANCEL' | translate }}
            </button>
            <button kui-button
                *ngIf="!handler.buttons || handler.buttons.includes('save')"
                [disabled]="!saveable"
                (click)="onSave.emit()"
                color="primary">
                {{ 'DIALOG.SAVE' | translate }}
            </button>
            <button kui-button
                *ngIf="handler.buttons && handler.buttons.includes('ok')"
                (click)="onSave.emit()"
                color="primary">
                {{ 'DIALOG.OK' | translate }}
            </button>
        </div>
    </div>
</div>